module.exports = __webpack_public_path__ + "static/media/scene5_didi3.6fb91302.wav";